var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'nuxt-property-decorator';
import { searchCharts } from '~/api/song';
import ChartList from '~/components/pages/charts/ChartList.vue';
let ChartLevelPage = class ChartLevelPage extends Vue {
    constructor() {
        super(...arguments);
        /** Chart list */
        this.charts = [];
    }
    get selected() {
        return parseInt(this.$route.params.level, 10);
    }
    get playStyle() {
        return this.$route.params.style === 'double' ? 2 : 1;
    }
    /** Page title */
    get title() {
        const style = this.$route.params.style.toUpperCase();
        return `${style} ${this.selected}`;
    }
    /** 1-19 */
    get levelList() {
        return [...Array(19).keys()].map(i => i + 1);
    }
    /** `style` expected 'single' or 'double' & `level` expected [1-20] */
    validate({ params }) {
        const level = parseInt(params.level, 10);
        return (['single', 'double'].includes(params.style) &&
            /^\d{1,2}$/.test(params.level) &&
            level >= 1 &&
            level <= 20);
    }
    /* istanbul ignore next */
    head() {
        return { title: this.title };
    }
    /** Get `charts` from API */
    async fetch() {
        this.charts = await searchCharts(this.$http, this.playStyle, this.selected);
    }
};
ChartLevelPage = __decorate([
    Component({ fetchOnServer: false, components: { ChartList } })
], ChartLevelPage);
export default ChartLevelPage;
